<template>
    <div class="row py-3">

        <div class="col-3"><button @click="search()" class="btn btn-success w-100 mr-2">
                {{ currentCity }} {{ currentJob }}
            </button></div>
        <div class="col-2"><button @click="refresh()" class="btn btn-dark w-100">
                Refresh
            </button></div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            currentCity: '',
            currentJob: '',
            jobs: [
                "Dentist",
                "Doctor",
                "Chiropractor",
                "Electrician",
                "Plumber",
                "HVAC Technician",
                "Cleaning Professional",
                "Real Estate Agent",
                "Landscaper",
                "Pest Control",
                "Real Estate Agent",
                "Property Manager",
                "Personal Trainer",
                "Gym",
                "Yoga Instructor",
                "Fitness Instructor",
                "Fitness Coach",
                "Hair Stylist",
                "Barber",
                "Nail Technician",
                "Accountant",
                "Spa Therapist",
                "stationery",
                "Beauty Salon",
                "Hair Salon",
                "Solar Installer",
                "Online Shop",
                "Shopify Store",
                "Business Coach",
                "Life Coach",
                "Career Coach",
                "Consultant",
                "Financial Advisor",
                "Marketing Consultant",
                "Wine",
                "Social Media Influencer",
                "Social Media Management",
                "Content Creator"
            ],
            cities: [
                "Tokyo",
                "Delhi",
                "Shanghai",
                "Dhaka",
                "Cairo",
                "Sao Paulo",
                "Mexico City",
                "Beijing",
                "Mumbai",
                "Osaka",
                "Kinshasa",
                "Istanbul",
                "Guangzhou",
                "Karachi",
                "Chongqing",
                "Lagos",
                "Buenos Aires",
                "Paris",
                "London",
                "New York City",
                "Los Angeles",
                "Chicago",
                "Houston",
                "Toronto",
                "Sydney",
                "Jakarta",
                "Seoul",
                "Bangkok",
                "Lima",
                "Bogota",
                "Madrid",
                "Moscow",
                "Bangalore",
                "Lahore",
                "Rio de Janeiro",
                "Tehran",
                "Philadelphia",
                "Dallas",
                "Miami",
                "Singapore",
                "Hong Kong",
                "Berlin",
                "Rome",
                "Montreal",
                "Barcelona",
                "Munich",
                "Amsterdam",
                "Dubai",
                "Johannesburg",
                "Cape Town",
                "Durban",
                "Pretoria",
                "Melbourne",
                "Brisbane",
                "Perth",
                "Auckland",
                "Wellington",
                "Copenhagen",
                "Stockholm",
                "Oslo",
                "Helsinki",
                "Vienna",
                "Zurich",
                "Geneva",
                "Budapest",
                "Prague",
                "Warsaw",
                "Dublin",
                "Edinburgh",
                "Glasgow",
                "Lisbon",
                "Athens",
            ]
        };
    },

    mounted() {
        this.refresh();
    },

    methods: {
        getRandomItem(array) {
            return array[Math.floor(Math.random() * array.length)];
        },

        refresh() {
            this.currentCity = this.getRandomItem(this.cities);
            this.currentJob = this.getRandomItem(this.jobs);
        },

        search() {
            if (this.currentCity && this.currentJob) {
                const query = `${this.currentCity.replace(/\s+/g, '+')}+${this.currentJob.replace(/\s+/g, '+')}+contact+email+@`;
                // Generate random page number between 1-20
                const randomPage = Math.floor(Math.random() * 10) + 1; // 1 to 20
                const startResult = (randomPage - 1) * 10; // Convert to Google's start parameter
                const searchUrl = `https://www.google.com/search?q=${query}&start=${startResult}`;
                window.open(searchUrl, '_blank');
            }
        },
    }

}

</script>

<style scoped>
.btn,
.btn-success,
.btn-dark { border: none !important; }
</style>